module.exports = __webpack_public_path__ + "static/info_slogan-fbfceb5243d52fdd7b43c64e4b59bec3.png";